import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

import { State } from '®app/ngrx';

import {
  RequestReviewHideModalAction,
  RequestReviewSendRequestAction,
} from './request-review.actions';
import {
  RequestReviewState,
  selectRequestReviewState,
} from './request-review.state';

@Component({
  selector: 'rl-request-review-modal',
  templateUrl: './request-review-modal.component.html',
})
export class RequestReviewModalComponent implements OnInit, OnDestroy {
  @ViewChild('requestReviewModal', { static: true })
  public requestReviewModal: ModalDirective;

  private subscription: Subscription;
  state: RequestReviewState;

  constructor(private cd: ChangeDetectorRef, private store: Store<State>) {}

  ngOnInit() {
    this.subscription = this.store
      .select(selectRequestReviewState)
      .subscribe(state => {
        this.state = state;

        const { isShown } = this.state.modalControls;
        if (isShown && !this.requestReviewModal.isShown) {
          this.requestReviewModal.show();
        } else if (!isShown && this.requestReviewModal.isShown) {
          this.requestReviewModal.hide();
        }

        this.cd.markForCheck();
      });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onSend() {
    this.store.dispatch(
      new RequestReviewSendRequestAction({
        listId: this.state.listId,
      }),
    );
  }

  onHide() {
    this.store.dispatch(new RequestReviewHideModalAction());
  }
}
